import { useTranslate } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { Icon } from '@repo/ui/components'
import { useSearchParams } from 'next/navigation'

const CancelButton = () => {
  const { push } = useRouter()
  const { t } = useTranslate()
  const searchParams = useSearchParams()
  const mobileOrEmail = searchParams.get('mobileOrEmail') ?? ''
  return (
    <button
      className='!text-neutral-100 bg-neutral-950/50 rounded-sm p-xs absolute font-bold top-md right-md z-10 flex items-center gap-2xs cursor-pointer'
      onClick={() => push(`/auth/kyc?mobileOrEmail=${mobileOrEmail}`)}
    >
      <Icon name='XmarkLine' size='sm' color='fill-neutral-100' />
      {t('common_cancellation')}
    </button>
  )
}

export { CancelButton }
